/**
 * Career interest chips for a student list/profile row.
 * Same order as PersonalData "Career Interests".
 */
export const getStudentCareerInterests = student => {
	if (!student) return []
	const { career, category, sub_category: subCategory } = student
	const items = []
	if (career) items.push(career)
	if (category && category !== career) items.push(category)
	if (subCategory && subCategory !== career && subCategory !== category) {
		items.push(subCategory)
	}
	return [...new Set(items.filter(Boolean))]
}
